import {Box} from "@mui/system";
import {Link} from "@mui/material";

interface EnorllmentLinkProps {
  handleInviteClick: () => void;
  inviteLinkColor: string;
  isPending: boolean;
  showEnrollmentLink: boolean;
}

export const EnrollmentLink: React.FC<EnorllmentLinkProps> = ({ handleInviteClick, inviteLinkColor, isPending, showEnrollmentLink }) => (
  showEnrollmentLink ?
    <Box mt={2} display={"flex"} justifyContent={"flex-end"} sx={{ width: '100%' }}>
      <Link underline="always" onClick={handleInviteClick} sx={{ color: inviteLinkColor, fontSize: '0.875rem' }}>
        {isPending ? 'Resend Invitation' : 'Send Invitation'}
      </Link>
    </Box> : null
);
